/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsBaseForAzureSubscription extends models.ServiceAccountNativeDetailsBaseForAzure {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsBaseForAzureSubscription");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsBaseForAzureSubscription.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsBaseForAzureSubscription>): ServiceAccountNativeDetailsBaseForAzureSubscription {
        let obj = Object.assign(new ServiceAccountNativeDetailsBaseForAzureSubscription(), model);
        ServiceAccountNativeDetailsBaseForAzureSubscription.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsBaseForAzureSubscription>): ServiceAccountNativeDetailsBaseForAzureSubscription {
        if (!model) return null;
        return ServiceAccountNativeDetailsBaseForAzureSubscription.newInstance(<ServiceAccountNativeDetailsBaseForAzureSubscription> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsBaseForAzureSubscription) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsBaseForAzureSubscription.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsBaseForAzureSubscription): boolean {
        if (models.ServiceAccountNativeDetailsBaseForAzure.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsBaseForAzureSubscription.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.default_values) {
            models.SelfServiceDefaultValuesForAzure.fixupPrototype(this.default_values);
        }
    }

    /**
     * Subscription Id. This is a required field
     */
    subscription_id: string;

    /**
     * Subscription Name
     */
    subscription_name: string;

    /**
     * Azure Subscription Type. This is a required field.
     */
    subscription_type: models.AzureSubscriptionType;

    /**
     * SelfService Default Values
     */
    default_values: models.SelfServiceDefaultValuesForAzure;

}
